import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { ProductosApiService } from 'src/app/service/api/productos-api';
import { BaseForm } from 'src/app/view/base-form';
import { ProductoBioFormDefinition } from './form-control/form-definition';

import { ProductosModel } from 'src/app/models/productos/productos.model';

@Component({
    selector: 'app-producto-bio-form',
    standalone: false,
    templateUrl: './producto-bio-form.component.html',
    styleUrls: ['./producto-bio-form.component.css']
})
export class ProductoBioFormComponent extends BaseForm<ProductosModel> implements OnInit {
    public override model: ProductosModel = { nombre: '', materia_activa: '' };
    public form!: ProductoBioFormDefinition;

    constructor(
        public dashboardEvents: DashboardService,
        public productosApi: ProductosApiService,
        public override router: Router,
        public override route: ActivatedRoute,
    ) {
        super(
            route,
            router,
            dashboardEvents,
            productosApi.productos.PUT,
            productosApi.productos.POST,
            'productos',
            'Actualizar Bio',
            'Alta de Producto Bio',
        );
    }

    public ngOnInit(): void {
        this.softInit(this.getType());
        this.model = { ...this.model, ...this.getModel() };
        this.form = new ProductoBioFormDefinition(this.getType(), this.model);
    }

    public override goBack(): void {
        this.router.navigate(['dashboard', 'productos-bio']);
    }
}
